const key = id => `loja_carrinho_v1_${id}`;
const pendingKey = id => `loja_checkout_pendente_${id}`;

// Only product ids/quantities are stored. Prices and stock always come from the current catalog.
export function reconciliarCarrinho(items, products) {
  const catalog = new Map(products.filter(p => p.ativo !== false).map(p => [p.id,p]));
  const seen = new Set();
  return (Array.isArray(items) ? items : []).flatMap(item => {
    const product = catalog.get(item?.id);
    const requested = Math.floor(Number(item?.qtd));
    if (!product || seen.has(item.id) || !Number.isFinite(requested) || requested < 1) return [];
    seen.add(item.id);
    const stock = Math.max(0,parseInt(product.estoque) || 0);
    return [{ id:product.id, nome:product.nome, preco:Math.max(0,parseFloat(product.preco) || 0),
      fotoBase64:product.fotoBase64 || product.fotos?.find(f => f.tipo !== "video")?.url || null,
      encomenda:stock === 0, estoque:stock, qtd:Math.min(requested,stock || 999) }];
  });
}
export function lerCarrinho(id, products) {
  if (!id) return [];
  try { return reconciliarCarrinho(JSON.parse(sessionStorage.getItem(key(id))),products); } catch { return []; }
}
export function salvarCarrinho(id, items) {
  if (!id) return;
  try { sessionStorage.setItem(key(id),JSON.stringify(items.map(({id,qtd}) => ({id,qtd})))); } catch {}
}
export function aguardarLoginCheckout(id, pending) {
  if (!id) return;
  try { if (pending) sessionStorage.setItem(pendingKey(id),"1"); else sessionStorage.removeItem(pendingKey(id)); } catch {}
}
export function checkoutAguardandoLogin(id) {
  try { return !!id && sessionStorage.getItem(pendingKey(id)) === "1"; } catch { return false; }
}
